// Charset validation for storage identifiers (uploadId / fileId) before they are placed
// into API paths. This mirrors the server-side StorageIdentifierGuard and is defense in
// depth: the backend is authoritative, but validating here fails fast and prevents a
// tampered identifier (e.g. from a manipulated URL) from being sent at all.
//
// uploadIds use [A-Za-z0-9_]; fileIds are crypto.randomUUID() values ([0-9a-fA-F-]).
// Allowing hyphen covers both.
const SAFE_STORAGE_ID = /^[A-Za-z0-9_-]+$/;
const MAX_STORAGE_ID_LENGTH = 128;

export function isSafeStorageId(value: unknown): value is string {
  return (
    typeof value === 'string' &&
    value.length > 0 &&
    value.length <= MAX_STORAGE_ID_LENGTH &&
    SAFE_STORAGE_ID.test(value)
  );
}

export function assertSafeStorageId(value: unknown, name = 'identifier'): string {
  if (!isSafeStorageId(value)) {
    throw new Error(`Invalid ${name}`);
  }
  return value;
}
